import { CalculationConfig } from '@calculations/types/calculation-config';
import { PriceStrategySnapWorkOrder } from '@snap-types/transforms/price-strategy/shared';
import { Nullish } from '@snap-types/types/nullish';

import { QuoteBuilderOperationType } from '../../types/state/operation';
import { QuoteBuilderWorkOrderType } from '../../types/state/work-order';
import { transformSnapOperationToStoreState } from './transform-operation';

export function transformSnapWorkOrderToStoreState(
  workOrder: Nullish<PriceStrategySnapWorkOrder>,
  calculationConfig: CalculationConfig,
): QuoteBuilderWorkOrderType | null {
  if (!workOrder) {
    return null;
  }

  const operationUuids: string[] = [];
  const snapOperations: Record<string, QuoteBuilderOperationType> = {};

  for (const snapOperation of workOrder.snapOperations) {
    const { uuid, operation } = transformSnapOperationToStoreState(
      snapOperation,
      calculationConfig,
    );
    operationUuids.push(uuid);
    snapOperations[uuid] = operation;
  }

  return {
    uuid: workOrder.uuid,
    drawingId: workOrder.drawingId ?? null,
    drawingRevisionNo: workOrder.drawingRevisionNo ?? null,

    originalWorkOrderUuid: workOrder.originalWorkOrderUuid ?? null,

    snapOperationUuids: operationUuids,
    snapOperations,
  };
}
